import React, { useState } from 'react'
import Module from '../../../layout/Module'
import List from './List/List'
import ButtonStartIcon from '../../../button/ButtonStartIcon'
import DialogRole from './DialogRole/DialogRole'
import { useSelector } from 'react-redux'
import RolesEditor from './Editor/RolesEditor'

const Roles = () => {
  const [type, setType] = useState(null)
  const [formData, setFormData] = useState({})
  // MF-576 — only the Maestro role edits permissions; the server checks it again
  const isMaestro = useSelector((state) =>
    (state?.session?.profile?.roles || []).some((role) => (role.id || role.name) === 'Maestro')
  )
  const [editing, setEditing] = useState(false)
  const permissions = useSelector((state) => state?.session?.permissions.role || {})
  const sync = useSelector((state) => state?.session?.permissions.sync || {})
  const onModal = (type, data) => {
    setType(type)
    setFormData(data)
  }

  return (
    <Module>
      <Module.Header title='Roles'>
        <div className='flex justify-end items-center w-full gap-2'>
          {sync?.sync && (
            <ButtonStartIcon
              onClick={() => onModal('sync', {})}
              startIcon='sync'
              color='secondary'
              bGcolor='secondary'
            >
              Sync
            </ButtonStartIcon>
          )}
          {isMaestro && !editing && (
            <ButtonStartIcon
              onClick={() => setEditing(true)}
              startIcon='pencil'
              color='secondary'
              bGcolor='secondary'
            >
              Edit permissions
            </ButtonStartIcon>
          )}
          {permissions?.['created-custom-role'] && (
            <ButtonStartIcon
              onClick={() => onModal('create', {})}
              startIcon='plus'
              color='secondary'
              bGcolor='secondary'
            >
              Create
            </ButtonStartIcon>
          )}
        </div>
      </Module.Header>
      <Module.Body>
        <Module.BodyFullContainer>
          {editing ? <RolesEditor onClose={() => setEditing(false)} /> : <List onModal={onModal} />}
        </Module.BodyFullContainer>
      </Module.Body>
      {type && <DialogRole show={!!type} type={type} formData={formData} onClose={() => onModal(null, {})} />}
    </Module>
  )
}

export default Roles
